import { render, staticRenderFns } from "./DatasetLink.vue?vue&type=template&id=494609de&"
import script from "./DatasetLink.vue?vue&type=script&lang=js&"
export * from "./DatasetLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports